import styled from 'styled-components';

export const FilterCard = styled.div`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border-radius: 12px;
	padding: 16px;
	width: 100%;
`;

export const CheckboxContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
